<div [formGroup]="promptForm" class="record-hint" fxLayout="column">
    <mat-radio-group class="prompter-btn" fxLayoutAlign="space-between center" formControlName="item_type_value">
        <mat-radio-button [value]="MaterialModelType.TEXT">
            <mat-icon matTooltip="Write a text and let ChatGPT give you an answer">text_fields</mat-icon>
        </mat-radio-button>
        <!-- <ng-container *ngIf="advancedModeSub | async"> -->
        <mat-radio-button *ngIf="advancedModeSub | async" [value]="MaterialModelType.VIDEO">
            <mat-icon [matMenuTriggerFor]="vlms" matTooltip="Write a text and let ChatGPT create a video"
                >videocam</mat-icon
            >
        </mat-radio-button>
        <mat-radio-button *ngIf="advancedModeSub | async" [value]="MaterialModelType.AUDIO">
            <mat-icon matTooltip="Write a text and let ChatGPT create an audio">audiotrack</mat-icon>
        </mat-radio-button>
        <!-- </ng-container> -->
        <mat-radio-button [value]="MaterialModelType.IMAGE">
            <mat-icon i18n-matTooltip matTooltip="Write a text and let ChatGPT create an image">image</mat-icon>
        </mat-radio-button>
    </mat-radio-group>
    <div fxLayoutGap="5px" class="advancedMode" fxLayoutAlign="inherit baseline">
        <mat-form-field class="prompt-input" fxFlex="0 1 100%">
            <textarea
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                #input
                matInput
                type="text"
                [placeholder]="placeholder"
                formControlName="prompt"
            >
            </textarea>

            <!-- <mat-icon class="disable-icon" matSuffix>mic</mat-icon> -->

            <!-- <mat-error i18n>Prompter text is required!</mat-error> -->
        </mat-form-field>
        <button class="thinking-button" *ngIf="advancedModeSub | async" mat-icon-button [matMenuTriggerFor]="think">
            <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <button
            class="thinking-button"
            *ngIf="!(advancedModeSub | async)"
            mat-icon-button
            (click)="showQuiz = !showQuiz"
        >
            <mat-icon>{{ showQuiz ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
        </button>
    </div>
    <div
        class="audio-settings"
        fxLayout="column"
        fxLayoutGap="10px"
        *ngIf="promptForm.value.item_type_value === MaterialModelType.AUDIO"
        fxFlex="grow"
    >
        <div i18n class="speaker">Speaker</div>
        <div formGroupName="metadata" fxLayout="row" class="w-100" fxLayoutGap="20px" fxLayoutAlign="start center">
            <app-unified-style-dropdown
                [options]="model?.options"
                searchPlaceholder="Select speaker"
                i18n-searchPlaceholder
                [displayMode]="'dropdown'"
                formControlName="voice_name"
            ></app-unified-style-dropdown>
        </div>
    </div>
    <ng-container *ngIf="userLangId$ | async; let userLangId">
        <div *ngIf="showTags" fxFlex="grow">
            <app-tag-chip-select
                placeholder="Add Tag"
                i18n-placeholder
                [language_id]="userLangId"
                formControlName="tag_ids"
            ></app-tag-chip-select>
        </div>
    </ng-container>
    <div fxLayout="column" *ngIf="showQuiz" class="vtq-wrapper">
        <create-test-by-ai [hasCreateMaterialCheckBox]="true" (valuesChange)="vtqData = $event"></create-test-by-ai>
    </div>
    <div fxFlex="grow" fxLayoutAlign="start center" class="mt-1 action-btns-ai">
        <ng-container *ngIf="authUser$ | async; let authUser">
            <button class="list" mat-button matTooltip="Check materials list" (click)="listingMaterial(authUser)">
                <mat-icon>format_list_bulleted</mat-icon>
                <span i18n>List</span>
            </button>
        </ng-container>
        <button
            *ngIf="promptForm.value.prompt"
            matTooltip="Add quiz or course based on prompt"
            i18n-matTooltip
            class="tag-btn"
            [ngClass]="{
                'quiz-displayed': showQuiz,
                'quiz-hidden': !showQuiz
            }"
            mat-icon-button
            (click)="showQuiz = !showQuiz"
        >
            <mat-icon
                fxFlex="0 0 auto"
                fontSet="klickdata"
                fontIcon="kd-icon-test"
                class="course-plan-icon side-nave-icon no-shadow"
            ></mat-icon>
        </button>
        <button
            matTooltip="Add tags"
            i18n-matTooltip
            class="tag-btn"
            [ngClass]="{
                'tags-displayed': showTags,
                'tags-hidden': !showTags,
                'has-tags': promptForm.value.tag_ids?.length
            }"
            mat-icon-button
            (click)="showTags = !showTags"
        >
            <mat-icon>tag</mat-icon>
        </button>
        <button
            class="edit"
            [disabled]="!(currentResource$ | async)"
            mat-button
            matTooltip="View last created resource"
            (click)="editMaterial()"
        >
            <mat-icon>edit</mat-icon>
            <span i18n>View</span>
        </button>
        <button
            [disabled]="!promptForm.value.prompt"
            class="create"
            mat-button
            [matTooltip]="getSubmitBtnTooltip()"
            (click)="prompterLoading.next(true); addMaterial()"
        >
            <mat-icon class="add-ai-btn" [ngClass]="{ 'on-loading': prompterLoading.value }">smart_toy</mat-icon>
            <span i18n>Create</span>
        </button>
    </div>
</div>
<!-- Video Model Selector Menu -->
<mat-menu #vlms="matMenu">
    <button mat-menu-item class="video-lms-item" [disabled]="false" [class.selected]="true">
        <span>Sora 2</span>
    </button>
    <button mat-menu-item class="video-lms-item" [disabled]="false" [class.selected]="true">
        <span>Veo 3.1</span>
    </button>
</mat-menu>
<mat-menu #think="matMenu">
    <mat-checkbox class="pl-1" (click)="$event.stopPropagation()" [checked]="false" [indeterminate]="false" i18n
        >Deep think</mat-checkbox
    >
    <mat-checkbox class="pl-1" (click)="$event.stopPropagation()" [checked]="false" [indeterminate]="false" i18n
        >Display thinking in material</mat-checkbox
    >
</mat-menu>
